import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Our Programs" },
    { to: "/impact", label: "Impact" },
    { to: "/gallery", label: "Photo Gallery" },
    { to: "/events", label: "Upcoming Events" },
    { to: "/blog", label: "Blog" },
    { to: "/contact", label: "Contact Us" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0B3D91]/95 shadow-lg backdrop-blur" : "bg-[#0B3D91]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16 text-white">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img
            src="/images/download (28).png"
            alt="EthioCare Logo"
            className="h-10 w-10 object-contain"
          />
          <span className="font-semibold text-xl tracking-wide">EthioCare</span>
        </Link>

        {/* Hamburger Menu (Mobile) */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white focus:outline-none text-3xl"
        >
          {menuOpen ? "✕" : "☰"}
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex space-x-6 items-center">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`relative font-medium transition-all duration-200 ${
                location.pathname === link.to
                  ? "text-[#CDB937]"
                  : "hover:text-[#CDB937]"
              }`}
            >
              {link.label}
              {location.pathname === link.to && (
                <motion.span
                  layoutId="underline"
                  className="absolute left-0 -bottom-1 w-full h-[2px] bg-[#CDB937]"
                />
              )}
            </Link>
          ))}

          {/* Donate Button */}
          <Link
            to="/donate"
            className="bg-[#CDB937] text-[#0B3D91] font-semibold px-4 py-2 rounded-full hover:bg-yellow-400 transition-all duration-300 shadow-md"
          >
            Donate
          </Link>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden bg-[#0B3D91] text-white text-center space-y-2 py-4 shadow-lg"
          >
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className={`block py-2 font-medium transition-colors duration-200 ${
                  location.pathname === link.to
                    ? "text-[#CDB937]"
                    : "hover:text-[#CDB937]"
                }`}
              >
                {link.label}
              </Link>
            ))}

            <Link
              to="/donate"
              onClick={() => setMenuOpen(false)}
              className="inline-block mt-2 bg-[#CDB937] text-[#0B3D91] font-semibold px-5 py-2 rounded-full hover:bg-yellow-400 transition-all duration-300 shadow-md"
            >
              Donate
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
